


















import Vue from 'vue';
import { applicationRepository } from '@/api';
import ApplicationOverviewTemplate from '@/components/templates/applicationOverviewTemplate/ApplicationOverviewTemplate.vue';
import { Application } from '@/api/interfaces/application/application';
import { contentServices } from '@/services/contentService';
import type { ApplicationOverviewContent } from '@/api/interfaces/content/app/applicationOverviewContent';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import { SpinnerState } from '@/enums/spinnerState';
import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';
import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';
import { ServiceError } from '@/api/interfaces/serviceError';
import { alertService } from '@/services/alertService';
import { MessageType } from '@/enums/messageType';
import { dialogueMessageService } from '@/services/dialogueMessageService';
import { isServiceError } from '@/api/interfaces/typeGuards';
import router from '@/router';
import { ApplicationUpdateDataModel } from '@/types/app/application/applicationUpdateDataModel';
import { Pagination } from '@/api/interfaces/common/pagination';

export default Vue.extend({
    name: 'ApplicationOverview',
    components: {
        ApplicationOverviewTemplate,
        SpinnerArea,
    },
    data: () => {
        return {
            gridSpinner: SpinnerState.off,
            applicationOverviewContent: null as ApplicationOverviewContent | null,
            enumsContent: null as EntryListContent | null,
            applicationStatusItems: null as Record<
                string,
                ApplicationStatusDetail
            > | null,
            applications: [] as Application[],
            pagination: {} as Pagination,
            applicationUpdateData: new ApplicationUpdateDataModel(),
            contentLoaded: false,
        };
    },
    created() {
        if (this.$route.query.code === 'unauthorized') {
            dialogueMessageService.show('unauthorized', MessageType.error);
        }
    },
    async mounted() {
        this.gridSpinner = SpinnerState.opaque;

        const content = await contentServices.app.requestContentOnce();
        this.applicationOverviewContent =
            content.pages.applicationOverviewContent;
        this.enumsContent = content.enumsContent;
        this.applicationStatusItems = content.applicationStatusItems;

        this.contentLoaded = !!this.enumsContent;

        this.applicationUpdateData = new ApplicationUpdateDataModel();
        await this.updateApplications(this.applicationUpdateData);

        this.gridSpinner = SpinnerState.off;
    },
    methods: {
        updateApplicationsAfterCopy(copiedApplicationId: string): void {
            router.push(`/antrag/${copiedApplicationId}`);
        },
        updateApplicationsAfterDelete(deletedApplicationId: string): void {
            this.applications = this.applications.filter(
                (application) =>
                    application.applicationId !== deletedApplicationId,
            );
        },
        async updateApplications(
            data: ApplicationUpdateDataModel,
        ): Promise<void> {
            this.gridSpinner = SpinnerState.transparent;

            try {
                const applicationResult = await applicationRepository.fetchApplications(
                    data,
                );
                this.applications = applicationResult.applications;
                this.pagination = {
                    limit: applicationResult.limit,
                    offset: applicationResult.offset,
                    results: applicationResult.results,
                    total: applicationResult.total,
                };
            } catch (error) {
                if (isServiceError(error)) {
                    alertService.clear();
                    alertService.pushAlert({
                        alert: {
                            type: MessageType.error,
                            identifier: (error as ServiceError).messageCode,
                        },
                        displayDuration: 0,
                    });
                }
            }

            this.gridSpinner = SpinnerState.off;
        },
    },
});
